<div
  class="header-title"
  [ngClass]="isActive == title ? 'header-title-active' : ''"
>
  <div class="header-title__inner-block">
    <div class="inner-block__total">{{ total }}</div>
    <div class="inner-block__title">{{ title }}</div>
  </div>
</div>
